var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-role": "demo" } },
    [
      _c(
        "div",
        { staticClass: "block", attrs: { block: "base" } },
        [_c("BaseExample")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block", attrs: { block: "auto-close" } },
        [_c("AutoCloseExample")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block", attrs: { block: "close-callback" } },
        [_c("CloseCallbackExample")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block", attrs: { block: "style" } },
        [_c("StyleExample")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block", attrs: { block: "size" } },
        [_c("SizeExample")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block", attrs: { block: "action" } },
        [_c("ActionExample")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block", attrs: { block: "custom-component" } },
        [_c("CustomComponentExample")],
        1
      ),
      _vm._v(" "),
      _c("VueDialog", { attrs: { zIndex: 3000 } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ce5b23b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ce5b23b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resource/Demo.vue
// module id = null
// module chunks = 